// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import ElementUI from 'element-ui'

import "babel-polyfill"
import 'element-ui/lib/theme-chalk/index.css'
// import "./assets/icon/iconfont.css"

import RouterTab from 'omnis-vue-router-tab'
import 'omnis-vue-router-tab/dist/lib/omnis-vue-router-tab.css'
import VueClipboards from 'vue-clipboards';
import "./assets/icon/iconfont.css"
import 'es6-promise/auto'

import plTable from 'pl-table'

import 'pl-table/themes/index.css' // 引入样式（必须引入)，请查看webpack是否配置了url-loader对woff，ttf文件的引用,不配置会报错哦

import 'pl-table/themes/plTableStyle.css'

import 'xterm/css/xterm.css'
import "xterm/lib/xterm.js"


// import echarts from 'echarts'
import GLOBAL_FUNCROLE from './api/userFuncRole.js'
import USER_FUNC_ROLE_FUNC from './api/userfuncrole_func'
import table_style from "@/components/common_page/mixin/table_style.js"
import zabbix from "@/components/common_page/mixin/zabbix.js"
import shrink_button from "@/components/common_page/css/shrink_button.css"

import middle_table_style from "@/components/common_page/mixin/middle_table_style.js"
import COMMON_FUNC from "./components/common_page/mixin/common.js"


import theme from './ni-theme/mixin/theme.js'
Vue.mixin(theme)
Vue.prototype.$_global_params = GLOBAL_FUNCROLE
// Vue.prototype.$echarts = echarts
//角色
Vue.mixin(USER_FUNC_ROLE_FUNC)
//table 样式
Vue.mixin(table_style)
Vue.mixin(zabbix)
// Vue.css(shrink_button)
Vue.mixin(middle_table_style)

Vue.mixin(COMMON_FUNC)


Vue.use(plTable);
Vue.use(VueClipboards);
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(RouterTab)
//防止重复点击
import preventReClick from "@/common/preventReClick.js"
import drag from "@/common/drag.js"
import loadmore from "@/common/loadmore.js"
// import 'jquery'
Vue.use(preventReClick)
Vue.use(drag)
Vue.use(loadmore)
import Toastr from 'vue2-toastr'
import 'vue2-toastr/dist/css/vue2-toastr.css'

Vue.use(Toastr)
import ProgressBar from 'vuejs-progress-bar'

Vue.use(ProgressBar)

Vue.directive('removeAriaHidden', {
  bind(el, binding) {
    let ariaEls = el.querySelectorAll('.el-radio__original');
    ariaEls.forEach((item) => {
      item.removeAttribute('aria-hidden');
    });
  }
});
// axios.defaults.crossDomain = true;
// axios.defaults.withCredentials = true;


axios.interceptors.response.use(function (response) {
  return response
}, function (error) {
  switch (error.response.status) {
    //当前请求没有，状态值。临时用一下
    case 500:
      error.message = "系统错误" + error.response.statusText
      // router.push({ path:'/system/common/404_page'});
      break;
    case 404:
      error.message = "您访问的接口不存在"
      // debugger
      // router.push({ path:'/system/common/404_page'});
      break;
    case 401:

      if (!(vue.not_login || vue.not_login === false)) {

        vue.not_login = true
        vue.$alert("没有登录！请先登录", "提示", {
          confirmButtonText: "确定",
          callback(result) {
            if (result == 'confirm') {
              let fromPath = vue.$router.history.current.fullPath
              let fromPath_split = fromPath.split('/');
              let last_str = fromPath_split.pop();
              let last_two_str = fromPath_split.pop();
              last_str = encodeURIComponent(last_str)
              last_two_str = encodeURIComponent(last_two_str)
              let fromPath_for = fromPath_split.join('/') + '/' + last_two_str + "/" + last_str;
              // let fromPath2 = fromPath_for + last_str

              localStorage.setItem('fromPath2', fromPath_for)
              vue.not_login = undefined
              router.push({path: '/system/login?redirect=' + encodeURIComponent(fromPath_for)})


            }

          }
        })
      }
      return false
    case 403:
      error.message = "没有权限"
      break
    default :
      error.message = "系统错误"
      break
  }
  vue.$message({
    message: error.message,
    type: 'error'
  })
})

Vue.config.productionTip = false


// import io from 'socket.io-client';
// const socket = io(window.location.origin);
// Vue.prototype.$_socket = socket;


/* eslint-disable no-new */
const vue = new Vue({

  router,
  render: h => h(App),

  data: {
    aa: '11'
  }
}).$mount("#app")



// WEBPACK FOOTER //
// ./src/main.js